import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-dialog-general',
    templateUrl: './dialog-general.component.html',
    styleUrls: ['./dialog-general.component.css'],
})
export class DialogGeneralComponent implements OnInit {

    @Input() headerText: string;
    @Input() bodyText: any;
    @Input() cancelButtonText: string;
    @Input() confirmButtonText: string;
    @Input() showReason: boolean;
    @Input() showPriceInput: boolean;

    translations: {};
    suspendReason: string = '';
    suspensionHours: number = 0;
    packageType: string = '';
    priceInput: number;

    @Output() onDialogConfirm: EventEmitter<void> = new EventEmitter<void>();
    @Output() onDialogCancel: EventEmitter<void> = new EventEmitter<void>();
    @Output() changeSuspendReason: EventEmitter<string> = new EventEmitter();
    @Output() changeSuspensionHours: EventEmitter<number> = new EventEmitter();
    @Output() changePackageType: EventEmitter<string> = new EventEmitter();
    @Output() changePrice: EventEmitter<number> = new EventEmitter();

    constructor() { /* noop */
    }

    ngOnInit() { /* noop */
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKey(event: KeyboardEvent) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.onCancelClick();
    }

    setReason(value: string) {
        this.suspendReason = value;
        this.changeSuspendReason.emit(this.suspendReason);
    }

    radioValueSuspensionHours(value: number) {
        this.suspensionHours = value;
        this.changeSuspensionHours.emit(this.suspensionHours);
    }

    radioPackageType(value: string) {
        this.packageType = value;
        this.changePackageType.emit(this.packageType);
    }

    setPrice(value: number) {
        this.priceInput = value;
        this.changePrice.emit(this.priceInput);
    }

    onConfirmClick() {
        this.onDialogConfirm.emit();
    }

    onCancelClick() {
        this.onDialogCancel.emit();
    }
}
